import { apiInstances } from '../../../../libs';

const { post: postUser } = apiInstances.userInstance;
const { post: postStorage } = apiInstances.storageInstance;

const IMAGE_TYPES = {
  SELFIE: 'selfie',
  DRIVERS_LICENSE: 'drivers_license',
};

function normalizeFileType(file) {
  const isPdf = file?.name?.toLowerCase().endsWith('.pdf');
  const hasInvalidMime =
    !file?.type || file.type === 'application/octet-stream';

  if (!isPdf || !hasInvalidMime) {
    return file;
  }

  return new File([file], file.name, {
    type: 'application/pdf',
    lastModified: file.lastModified,
  });
}

function getUploadedImageUrl(response) {
  const url = response?.data ?? response?.url ?? response;
  if (typeof url !== 'string' || !url) {
    throw new Error('KYC_UPLOAD_INVALID_RESPONSE');
  }
  return url;
}

async function uploadClouderImage({ idClouder, file, imageType }) {
  const formData = new FormData();
  formData.append('file', normalizeFileType(file));
  formData.append('image_type', imageType);

  const response = await postStorage(
    `/clouders/${encodeURIComponent(idClouder)}/upload-image`,
    formData
  );

  return getUploadedImageUrl(response);
}

async function submitSelfie({ id_clouder, selfie }) {
  const selfieUrl = await uploadClouderImage({
    idClouder: id_clouder,
    file: selfie,
    imageType: IMAGE_TYPES.SELFIE,
  });

  return postUser('/users/validate-kyc', { selfie: selfieUrl });
}

async function submitManual({ id_clouder, selfie, driver_license }) {
  const selfieUrl = await uploadClouderImage({
    idClouder: id_clouder,
    file: selfie,
    imageType: IMAGE_TYPES.SELFIE,
  });

  const driverLicenseUrl = await uploadClouderImage({
    idClouder: id_clouder,
    file: driver_license,
    imageType: IMAGE_TYPES.DRIVERS_LICENSE,
  });

  return postUser('/users/create-user-event', {
    id_user: id_clouder,
    event: 'MANUAL_ACTION_REQUIRED',
    validation: {
      selfie: selfieUrl,
      drivers_license: driverLicenseUrl,
    },
  });
}

export function createIdentityValidationGateway({
  submitSelfie: submitSelfieOverride = submitSelfie,
  submitManual: submitManualOverride = submitManual,
  cancelValidation = async () => undefined,
} = {}) {
  return {
    submitSelfie: submitSelfieOverride,
    submitManual: submitManualOverride,
    cancelValidation,
  };
}

export const identityValidationGateway = createIdentityValidationGateway();
